var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolleyballPlayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_3646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9618 12.6652C53.5885 11.4825 52.3269 10.8265 51.1449 11.1995L40.9508 14.4157L24.7854 17.0088L17.0321 13.7132L18.768 3.58999C18.9776 2.36779 18.1567 1.20708 16.9344 0.997507C15.7125 0.78793 14.5515 1.60879 14.3419 2.83099L12.3058 14.7052C12.1298 15.7314 12.6823 16.7439 13.6406 17.1511L21.6489 20.5551L21.972 35.7095L19.132 40.6166L7.75413 44.8915C6.30302 45.4367 5.56874 47.055 6.11394 48.5061C6.65927 49.9576 8.27813 50.6914 9.72854 50.1463L22.0458 45.5184C22.6532 45.2902 23.1628 44.8585 23.4879 44.297L28.504 35.0899L28.5874 35.081L28.4492 45.3706L19.6005 55.3297C18.5709 56.4885 18.6756 58.2625 19.8344 59.2921C20.9931 60.3217 22.7672 60.2168 23.7968 59.0581L33.3397 48.3177C33.7876 47.8137 34.039 47.1653 34.048 46.4911L33.8506 20.0729C33.8506 20.0729 42.0335 18.7833 42.1408 18.7494L52.4961 15.4824C53.6786 15.109 54.3348 13.8478 53.9618 12.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8724 14.7499C33.9444 13.1319 31.9441 4.34478 25.774 5.50923C19.7019 7.12716 21.7024 15.9143 27.8724 14.7499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7833 5.45313C40.6858 3.35641 41.0928 1.36748 41.6639 0.0234375C37.8769 0.561615 35.8157 5.07005 37.9512 8.29338C39.0822 8.07209 40.9055 7.41336 41.7833 5.45313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7914 6.5146C47.8334 6.31919 47.8661 6.11981 47.8868 5.91632C48.185 2.98013 46.0762 0.355778 43.1602 0C42.6274 0.994235 42.0073 2.75239 42.8676 4.61645C45.1335 4.43487 46.7739 5.51005 47.7914 6.5146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9565 10.7533C44.2029 10.9814 46.2668 9.80056 47.2724 7.92749C46.536 7.05145 45.1137 5.81402 43.031 5.95202C42.0989 8.09185 40.3199 9.02551 38.9309 9.43272C39.7486 10.1529 40.7898 10.6349 41.9565 10.7533Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_3646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolleyballPlayer);
export default __webpack_public_path__ + "static/media/volleyball-player.100f0e46e86c4b51a24395fa8085585d.svg";
export { ForwardRef as ReactComponent };